import React from "react";
import { INK, INK_3, LINE, BURGUNDY } from "../../Bureau/bureauTokens";

const DOW_SHORT = ["Lun", "Mar", "Mer", "Jeu", "Ven", "Sam", "Dim"];

// .pl-day-head — en-tête d'une colonne du planning : jour de semaine +
// numéro du jour (rond bordeaux si aujourd'hui), tag férié le cas échéant.
function DayHeaderCell({ date, isToday, holiday }) {
  return (
    <div
      className="flex flex-col items-center"
      style={{ gap: 3, padding: "9px 6px", borderLeft: `1px solid ${LINE}` }}
    >
      <span className="text-[10px] font-bold uppercase" style={{ color: isToday ? BURGUNDY : INK_3, letterSpacing: 0.6 }}>
        {DOW_SHORT[(date.getDay() + 6) % 7]}
      </span>
      <span
        className="flex items-center justify-center text-[14px] font-bold"
        style={{
          width: 28,
          height: 28,
          borderRadius: "50%",
          background: isToday ? BURGUNDY : "transparent",
          color: isToday ? "#fff" : holiday ? BURGUNDY : INK,
        }}
      >
        {date.getDate()}
      </span>
      {holiday && (
        <span
          className="text-[8px] font-bold uppercase truncate max-w-full text-center"
          style={{ color: BURGUNDY, letterSpacing: 0.3, lineHeight: 1.1 }}
        >
          {holiday}
        </span>
      )}
    </div>
  );
}

export default DayHeaderCell;
